import { mapState, mapActions } from 'vuex';
import { Money } from 'v-money';

import {
  OPERACAO_IMOVEL, TIPOS_IMOVEIS, AREA_PESQUISA_IMOVEL, QUANTIDADE_QUARTOS_IMOVEL,
  QUANTIDADE_SUITES_IMOVEL, STATUS_IMOVEL
} from '../../util/constantes.js';

import Util from '../../util/funcoes.js';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faRetweet } from '@fortawesome/free-solid-svg-icons';

library.add(faRetweet)

export default {
  components: {
    Money,
    FontAwesomeIcon
  },
  created() {
    this.dispararPesquisaImoveisParceria();
  },
  data() {
    return {
      infiniteLoadingImoveisDisponiveisId: 0,
      infiniteLoadingImoveisParceriaId: 0,
      linhasImoveisDisponiveisSelecionadas: [],
      linhasImoveisParceriaSelecionadas: [],
      pretendente: { imoveisParceria: undefined },
      relatorio: { nome: undefined, imovel: {}},
      money: {
        decimal: ',',
        thousands: '.',
        precision: 2,
        masked: false
      },

      hoverGravar: false,
      hoverRelatorio: false
    }
  },
  computed: {
    ...mapState('redeImobStore', {
      imovelDisponivelPesquisa(state) { return state.imovelDisponivelPesquisa },
      imoveisDisponiveis(state) { return state.listaImoveisDisponiveis },
      imovelParceriaPesquisa(state) { return state.imovelParceriaPesquisa },
      imoveisParceria(state) { return state.listaImoveisParceria }
    }),
    operacoesImovel() { return OPERACAO_IMOVEL },
    tiposImovel() { return TIPOS_IMOVEIS },
    areaImovel() { return AREA_PESQUISA_IMOVEL },
    quartosImovel() { return QUANTIDADE_QUARTOS_IMOVEL },
    suitesImovel() { return QUANTIDADE_SUITES_IMOVEL },
    statusImovel() { return STATUS_IMOVEL },
    labelQuantidadeImoveisDisponiveis() {
      switch(this.imoveisDisponiveisFiltrados.length) {
        case 0:
          return "Nenhum Imóvel encontrado";
        case 1:
          return "1 Imóvel encontrado";
        default:
          return `${this.imoveisDisponiveisFiltrados.length} Imóveis disponíveis`;
      }
    },
    labelQuantidadeImoveisParceria() {
      switch(this.imoveisParceria.length) {
        case 0:
          return "Nenhum Imóvel disponível para parceria";
        case 1:
          return "1 Imóvel disponível para parceria";
        default:
          return `${this.imoveisParceria.length} Imóveis disponíveis para parceria`;
      }
    },
    util() { return Util },
    imoveisDisponiveisFiltrados() {
      let idsImoveisParceria = this.imoveisParceria
        .map((imovel) => {
          return imovel.id;
        });
      
      return this.imoveisDisponiveis
        .filter((imovel) => {
          return !idsImoveisParceria.includes(imovel.id);
        });
    },
    habilitarBotaoAdicionarImoveisARedeImob() {
      return this.linhasImoveisDisponiveisSelecionadas.length > 0;
    },
    habilitarBotaoRemoverImoveisDaRedeImob() {
      return this.linhasImoveisParceriaSelecionadas.length > 0;
    }
  },
  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),
    ...mapActions('redeImobStore', [
      'limparImovelDisponivelPesquisa',
      'listarImoveis',
      'limparImoveisDisponiveisListados',
      'limparImoveisParceriaListados',
      'listarImoveisDisponiveisParceria',
      'adicionarAParceria',
      'removerDaParceria',
      'gravarImoveisParceria',
      'gerarRelatorioImoveisParceria'
    ]),
    limparImovelDisponivelPesquisaHandler() {
      this.limparImovelDisponivelPesquisa();
    },
    pesquisarImoveisDisponiveis($state) {
      if(this.imovelDisponivelPesquisa.pagina === 0) { this.showLoading() }
      this.listarImoveis(this.imovelDisponivelPesquisa)
        .then((resultado) => {
          switch(resultado.status) {
            case "ERRO":
              this.$message.error(resultado.mensagem);
              break;
            case "SUCESSO":
              if(this.imovelDisponivelPesquisa.pagina === 0) { this.hideLoading() }
              if(resultado.lista.length === 100) {
                this.imovelDisponivelPesquisa.pagina += 1;
                $state.loaded();
              } else if(resultado.lista.length > 0 && this.imovelDisponivelPesquisa.pagina === 0) {
                $state.loaded();
                $state.complete();
              } else {
                $state.complete();
              }
          }
        }).catch(() => {
          if(this.imovelDisponivelPesquisa.pagina === 0) { this.hideLoading() }
          this.$message.error("Não foi possível conectar-se ao servidor");
        });
    },
    dispararPesquisaImoveisDisponiveis() {
      this.imovelDisponivelPesquisa.pagina = 0;
      this.limparImoveisDisponiveisListados();
      this.infiniteLoadingImoveisDisponiveisId += 1;
    },
    dispararPesquisaImoveisParceria() {
      this.imovelParceriaPesquisa.pagina = 0;
      this.limparImoveisParceriaListados();
      this.infiniteLoadingImoveisParceriaId += 1;
    },
    pesquisarImoveisDisponiveisHandler() {
      this.dispararPesquisaImoveisDisponiveis();
    },
    pesquisarImoveisParceria($state) {
      if(this.imovelParceriaPesquisa.pagina === 0) { this.showLoading() }
      this.listarImoveisDisponiveisParceria(this.imovelParceriaPesquisa)
        .then((resultado) => {
          if(this.imovelParceriaPesquisa.pagina === 0) { this.hideLoading() }
          switch(resultado.status) {
            case "ERRO":
              $state.complete();
              this.$message.error(resultado.mensagem);
              break;
            case "SUCESSO":
              if(resultado.lista.length === 100) {
                this.imovelParceriaPesquisa.pagina += 1;
                $state.loaded();
              } else if(resultado.lista.length > 0 && this.imovelParceriaPesquisa.pagina === 0) {
                $state.loaded();
                $state.complete();
              } else {
                $state.complete();
              }
          }
        }).catch(() => {
          if(this.imovelParceriaPesquisa.pagina === 0) { this.hideLoading() }
          this.$message.error("Não foi possível conectar-se ao servidor");
        });
    },
    selecaoImovelDisponivelHandler(linhas) {
      this.linhasImoveisDisponiveisSelecionadas = linhas;
    },
    selecaoImovelParceriaHandler(linhas) {
      this.linhasImoveisParceriaSelecionadas = linhas;
    },
    adicionarImoveisARedeImob() {
      this.adicionarAParceria(this.linhasImoveisDisponiveisSelecionadas);
      this.linhasImoveisDisponiveisSelecionadas = [];
    },
    removerImoveisDaRedeImob() {
      this.removerDaParceria(this.linhasImoveisParceriaSelecionadas);
      this.linhasImoveisParceriaSelecionadas = [];
    },
    cliqueDuploLinhaImoveisDisponiveisHandler(imovel) {
      let payload = [imovel];

      this.adicionarAParceria(payload);
    },
    cliqueDuploLinhaImoveisParceriaHandler(imovel) {
      let payload = [imovel];

      this.removerDaParceria(payload);
    },
    gravarImoveisParceriaHandler() {
      this.pretendente.imoveisParceria = this.imoveisParceria;
      this.showLoading();
      this.gravarImoveisParceria(this.pretendente)
        .then((resultado) => {
          this.hideLoading();
          switch(resultado.status) {
            case "ERRO":
              this.$message.error(resultado.mensagem);
              break;
            case "SUCESSO":
              this.$message.success(resultado.mensagem);
          }
        }).catch(() => {
          this.hideLoading();
          this.$message.error("Não foi possível conectar-se ao servidor");
        });
    },
    gerarRelatorioImoveisParceriaHandler() {
      this.relatorio.nome = "IMOVEIS_PARA_PARCERIA";
      this.relatorio.imovel.disponivelParceria = true;
      this.showLoading();
      this.gerarRelatorioImoveisParceria(this.relatorio)
        .then((resultado) => {
          this.hideLoading();
          switch(resultado.status) {
            case "SUCESSO":
              window.open(resultado.mensagem, "_blank");
              break;
            case "FALHA":
              this.$message.error("Não foi possível gerar o relatório");
          }
        }).catch(() => {
          this.hideLoading();
          this.$message.error("Não foi possível conectar-se ao servidor");
        });
    }
  }
};